import styled from 'styled-components';
import { themeColor, THEME_PRIMARY } from '../../styles/basics/colors';

export const LinkContainer = styled.ul.attrs({ 'data-displayname': 'SubNav' })`
    display: flex;
    text-align: center;
    height: 100%;
    align-items: stretch;

    & > li {
        margin: 0 9px;
    }

    li > a {
        color: #000;
        font-size: 16px;
        height: 100%;
        display: inline-flex;
        align-items: center;

        &.nav-new > span {
            position: relative;

            span.new-label {
                position: absolute;
                font-size: 12px;
                top: 18px;
                left: 0;
                color: #7fc31c;
            }
        }
        &.active,
        &:hover {
            color: ${themeColor(THEME_PRIMARY)};
        }
    }
`;
